import { ROLE_TYPE } from '@utils/enums';
import { useFeatureFlagEnabled } from '@components/Atoms/FeatureFlagGuard/hooks';
import { useMemo } from 'react';
import { useUser } from '@reducers/user/hooks';

export const useLearningOutcomeReportsAccess = ({
  suspense = false,
}: { suspense?: boolean } = {}) => {
  const isLearningOutcomeReportsEnabled = useFeatureFlagEnabled({
    featureName: 'learning-outcome-reports',
    suspense,
  });
  return isLearningOutcomeReportsEnabled;
};

const IsLearningOutcomeReportsFlagEnabled = ({ children, fallback }) => {
  const isEnabled = useLearningOutcomeReportsAccess();
  const { role } = useUser();

  const hasRolePermission = useMemo(
    () => [ROLE_TYPE.INSTRUCTOR, ROLE_TYPE.DISTRICT_ADMIN].includes(role),
    [role],
  );

  if (!isEnabled || !hasRolePermission) {
    return fallback;
  }

  return children;
};

export default IsLearningOutcomeReportsFlagEnabled;
